<template>
  <div
    :class="{
      'rounded-14px border border-solid border-www-color-accent-soft bg-www-color-accent-almost-white px-6 py-5': true,
    }"
  >
    <div :class="{ 'mb-3 flex items-center gap-3': true }">
      <PtcIcon
        v-if="icon === 'computer'"
        :class="{
          'text-2xl leading-none text-www-color-accent': true,
        }"
        name="ptc-event-computer"
      />
      <PtcIcon
        v-if="icon === 'info'"
        :class="{
          'text-2xl leading-none text-www-color-accent': true,
        }"
        name="ptc-event-info"
      />
      <PtcIcon
        v-if="icon === 'exclamation'"
        :class="{
          'text-2xl leading-none text-www-color-accent': true,
        }"
        name="ptc-event-exclamation"
      />
      <span
        :class="{
          'text-15px font-bold text-www-color-neutral-dark': true,
        }"
      >
        {{ label }}
      </span>
    </div>
    <p
      :class="{
        'text-sm font-medium text-www-color-neutral-medium': true,
      }"
    >
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { ExtraDetails } from '~/sanity/types';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
defineProps<ExtraDetails>();
</script>
